import { downloadImage } from '~/utils/download'

export function useArticleImages() {
  const { $rudderstack } = useNuxtApp()

  const setDownloadLinkOnImages = (slug: string, content?: HTMLElement) => {
    if (!content) return

    const blockImages = content?.querySelectorAll('.wp-block-image') || []

    if (!blockImages.length) return

    blockImages.forEach((block: HTMLElement, index: number) => {
      if (!block) return

      const imageName = `${slug}-image${index + 1}`
      const image = block.querySelector('img')
      if (!image) return

      image.addEventListener('load', () => {
        const src = image.getAttribute('src') || ''
        if (!src) return

        const canRenderLink = src.split('/').every((part) => {
          if (part.includes('data:image')) return false
          return !part.includes('e_blur')
        })

        if (!canRenderLink) return

        const newSrc = src
          .split('/')
          .filter((_, index) => index !== 5 && index !== 6)
          .join('/')

        const link = `<button id="${imageName}-link" class="font-semibold !text-neutral !text-sm !no-underline active:!text-s-600">Download Image</button>`
        const oldLink = document.getElementById(`${imageName}-link`)

        if (oldLink) oldLink.remove()

        block.insertAdjacentHTML('beforeend', link)
        const newLink = document.getElementById(`${imageName}-link`)
        if (!newLink) return

        newLink.addEventListener('click', async () => {
          await downloadImage(newSrc, imageName)

          $rudderstack.trackDownloads({
            file_id: 'chart_download',
            file_name: imageName,
            file_type: 'png',
            file_format: 'png',
          })
        })
      })
    })
  }

  return {
    setDownloadLinkOnImages,
  }
}
